import React, { useEffect } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import Box from '@amzn/meridian/box';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';
import {
  fetchMeasureUnits,
  fetchRegions,
  fetchTaskGroups,
  fetchTasks,
  setTaskSearchFieldValue,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

import NonPhysicalTaskConfiguration from '../nonPhysicalTaskConfiguration/nonPhysicalTaskConfig';

import './taskConfiguration.scss';

import TaskConfigurationTabGroup from './taskConfigurationTabGroup/taskConfigurationTabGroup';
import TaskGroups from './taskGroups/taskGroups';
import Tasks from './tasks/tasks';

// **** Components **** //

/**
 * Default Component
 */
const TaskConfiguration = () => {
  const dispatch = useAppDispatch();
  const { userLoading } = useAppSelector((state) => state.user);
  const { TASKS, TASK_GROUPS, NON_PHYSICAL_TASKS: NON_PHYSICAL_TASK } = AdminConfigPaths.Task;

  // Fetch back-end data
  useEffect(() => {
    if (userLoading === 'fulfilled') {
      dispatch(fetchMeasureUnits());
      dispatch(fetchTasks());
      dispatch(fetchRegions());
      dispatch(fetchTaskGroups());
    }
    return () => {
      dispatch(setTaskSearchFieldValue(''));
    };
  }, [userLoading]);

  return (
    <div>
      <Box spacingInset="500 none none none">
        <TaskConfigurationTabGroup />
      </Box>

      <Routes>
        <Route index element={<Navigate to={TASKS} replace />} />
        <Route path={TASKS} element={<Tasks />} />
        <Route path={TASK_GROUPS} element={<TaskGroups />} />
        <Route path={NON_PHYSICAL_TASK} element={<NonPhysicalTaskConfiguration />} />
        <Route path="*" element={<Navigate to={TASKS} replace />} />
      </Routes>
    </div>
  );
};

// **** Export **** //

export default TaskConfiguration;
